import React, {useState, useEffect} from 'react';
import {createPortal} from 'react-dom';

import styles from './styles.module.scss';
import {Logo} from '../../assets';

export const Loader = ({percentage}) => {
  const [width, setWidth] = useState(0);

  useEffect(() => {
    const animateProgress = () => {
      setWidth(0);
      const id = setInterval(() => {
        setWidth((prevWidth) => (prevWidth + 1) % 101);
      }, 40);

      return () => clearInterval(id);
    };

    if (percentage === undefined) {
      animateProgress();
    } else {
      setWidth(percentage);
    }
  }, [percentage]);

  const portalRoot = document.getElementById('loader-portal');

  const loader = (
    <div className={styles.wrapper}>
      <div className={styles.loader}>
        <div className={styles.icon}>
          <Logo />
        </div>
        <div className={styles.progressContainer}>
          <div
            className={styles.progress}
            style={{
              width: `${width}%`,
            }}></div>
          <div className={styles.progressBar}></div>
        </div>
      </div>
      <div className={styles.decorLeft}>
        <div className={styles.ellipse}></div>
      </div>
      <div className={styles.decorRight}>
        <div className={styles.ellipse}></div>
      </div>
    </div>
  );

  return createPortal(loader, portalRoot);
};
